/**
 * An admin's preview of Task Force's free trial (22 Oct 2026; Settings → Free trial → Preview): one tab, opened at
 * /taskforce?preview=trial, where every request asks the server to answer as for someone on the trial. Kept in this
 * tab's sessionStorage, so the admin's other tabs stay as they are.
 */
const KEY = 'tf.previewTrial';

export const trialPreview = {
  on(): boolean {
    try {
      return sessionStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  },
  end(): void {
    try {
      sessionStorage.removeItem(KEY);
    } catch {
      /* nothing kept */
    }
  },
};

/** Before the app starts: a tab opened for the preview remembers it, and the address loses the marker. */
export function capturePreview(): void {
  const u = new URL(location.href);
  if (u.searchParams.get('preview') !== 'trial') return;
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    /* private mode: no preview */
  }
  u.searchParams.delete('preview');
  history.replaceState(null, '', `${u.pathname}${u.search}${u.hash}`);
}
